<div class="login-inside-container" id="div_login-inside-container_3f30cb4c">
  <img
    title="TRM image"
    src="../../../../assets/images/success.webp"
    width="60"
    aria-label="Success image"
    alt="TRM image"
    id="img_dd9a475f"
  />
  <h1 aria-label="Success" title="Success" id="h1_87b9eaca">Success!</h1>
  <span
    class="success-info"
    aria-label="You will receive an email shortly with information on how to proceed"
    title="You will receive an email shortly with information on how to proceed"
    id="span_success-info_91adab73"
    >You will receive an email shortly with information on how to proceed</span
  >
  <div class="btn-panel" id="div_btn-panel_7d958647">
    <button
      class="next-button"
      (click)="close()"
      id="button_next-button_699d83da"
    >
      CLOSE
    </button>
  </div>
</div>
